import * as React from "react";
import {
    PresenceBadgeStatus,
    DataGridBody,
    DataGridRow,
    DataGrid,
    DataGridHeader,
    DataGridHeaderCell,
    DataGridCell,
    TableColumnDefinition,
    TableRowId,
    Spinner,
} from "@fluentui/react-components";
import { GenericToolbar } from "./GenericToolbar";
import { CenteredContent } from "./CenteredContent";

type FileCell = {
    label: string;
    icon: JSX.Element;
};

type LastUpdatedCell = {
    label: string;
    timestamp: number;
};

type LastUpdateCell = {
    label: string;
    icon: JSX.Element;
};

type AuthorCell = {
    label: string;
    status: PresenceBadgeStatus;
};

type Item = {
    file: FileCell;
    author: AuthorCell;
    lastUpdated: LastUpdatedCell;
    lastUpdate: LastUpdateCell;
};

export interface GenericGridProps<T>
{
    items?: T[] | null;
    columns?: TableColumnDefinition<T>[];
    rowSelector?: ((item: any) => TableRowId) | undefined;
    actionButtons: React.ReactElement;
    onRowClick: (rowId: TableRowId) => unknown;
    onSelectionChange?: (selection: TableRowId[]) => unknown;
    bodyStyle?: React.CSSProperties;
}

export const GenericGrid: React.FC<GenericGridProps<any>> = ({columns, bodyStyle, items, rowSelector, actionButtons, onRowClick, onSelectionChange}) => {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <GenericToolbar actionButtons={actionButtons} />
            <DataGrid
                items={items ?? []}
                columns={columns ?? []}
                sortable
                selectionMode="multiselect"
                subtleSelection={true}
                onSelectionChange={(e, data) => onSelectionChange && onSelectionChange(Array.from(data.selectedItems.keys()))}
                getRowId={rowSelector}
                focusMode="composite"
            >
                <DataGridHeader>
                    <DataGridRow
                        selectionCell={{
                        checkboxIndicator: {
                            "aria-label": "Select all rows"
                        },
                        }}
                    >
                        {({ renderHeaderCell }) => (
                            <DataGridHeaderCell>{renderHeaderCell()}</DataGridHeaderCell>
                        )}
                    </DataGridRow>
                </DataGridHeader>
                { items != null
                    ? (
                        <DataGridBody<Item> style={bodyStyle}>
                            {({ item, rowId }) => (
                                <DataGridRow<Item>
                                    key={rowId}
                                    selectionCell={{
                                        checkboxIndicator: {
                                        "aria-label": "Select row"
                                        }
                                    }}
                                    style={{cursor: "pointer"}}
                                >
                                    {({ renderCell }) => (
                                        <DataGridCell onClick={() => onRowClick(rowId)}>{renderCell(item)}</DataGridCell>
                                    )}
                                </DataGridRow>
                            )}
                        </DataGridBody>
                    )
                    : (
                        <p>
                            <CenteredContent>
                                <Spinner />
                            </CenteredContent>
                        </p>
                    )
                }
            </DataGrid>
        </div>
    );
};